import Dexie from "dexie";
import {getSessionAppVersion, getSessionOperator} from "../../helper/session";
import moment from "moment";
import {INVOICE_TYPE, TRANSACTION_TYPE} from "../../constants";
import {get_browser, sortByDateDescending, sortSaleDt} from "../../helper/other";
import {doc, setDoc} from "firebase/firestore";
import {AUTH, DB} from "../../auth/FirebaseContext";
import {getInvoicesByUser, getInvoicesByUserForPeriod} from "../../helper";

export const offlineDB = new Dexie("ESIR_BUS_V2");
export const offline_tables = {
    all_refunded_invoices: 'all_refunded_invoices',
    all_advance_invoices: 'all_advance_invoices',
    all_accounting_invoices: 'all_accounting_invoices',
    all_normal_invoices: 'all_normal_invoices',
    all_tickets: 'all_tickets',
    all_copies_invoices: 'all_copies_invoices',
    all_training_invoices: 'all_training_invoices',
    all_unhandled_invoices: 'all_unhandled_invoices',
    all_advance_open_invoices: 'all_advance_open_invoices',
    all_advance_old_invoices: 'all_advance_old_invoices',
    all_errors: 'all_errors',
    checks: 'checks',
    items: 'items',
    customers: 'customers',
    operators: 'operators',
    settings: 'settings',
}

offlineDB.version(1).stores({
        all_refunded_invoices: `
        invoiceNumber,
        userLocation,
        userUid,
        buyerCostCenter,
        buyerTin,
        cashier,       
        invoiceType,
        items,
        paymentMethod,
        referentDocumentDT,
        referentDocumentNumber,
        sdcDateTime,
        taxItems,
        totalAmount,
        transactionType,
        isInsertedOffline
        `,
        all_advance_invoices: `
       invoiceNumber,
       userLocation,
       userUid,
        buyerCostCenter,
        buyerTin,
        cashier,       
        invoiceType,
        items,
        paymentMethod,
        referentDocumentDT,
        referentDocumentNumber,
        sdcDateTime,
        taxItems,
        totalAmount,
        transactionType,
        isInsertedOffline
        `,
        all_accounting_invoices: `
        invoiceNumber,
        userLocation,
        userUid,
        buyerCostCenter,
        buyerTin,
        cashier,       
        invoiceType,
        items,
        paymentMethod,
        referentDocumentDT,
        referentDocumentNumber,
        sdcDateTime,
        taxItems,
        totalAmount,
        transactionType,
        isInsertedOffline
        `,
        all_normal_invoices: `
        invoiceNumber,
        userLocation,
        userUid,
        buyerCostCenter,
        buyerTin,
        cashier,
        invoiceType,
        items,
        paymentMethod,
        referentDocumentDT,
        referentDocumentNumber,
        sdcDateTime,
        taxItems,
        totalAmount,
        transactionType,
        isInsertedOffline
        `,
        all_tickets: `
        timestamp,
        invoiceNumber,
        userLocation,
        userUid,
        buyerCostCenter,
        buyerTin,
        cashier,
        invoiceType,
        items,
        paymentMethod,
        referentDocumentDT,
        referentDocumentNumber,
        sdcDateTime,
        taxItems,
        totalAmount,
        transactionType,
        isInsertedOffline
        `,
        all_copies_invoices: `
        invoiceNumber,
        userLocation,
        userUid,
        buyerCostCenter,
        buyerTin,
        cashier,
        invoiceType,
        items,
        paymentMethod,
        referentDocumentDT,
        referentDocumentNumber,
        sdcDateTime,
        taxItems,
        totalAmount,
        transactionType,
        isInsertedOffline
        `,
        all_training_invoices: `
        invoiceNumber,
        userLocation,
        userUid,
        buyerCostCenter,
        buyerTin,
        cashier,        
        invoiceType,
        items,
        paymentMethod,
        referentDocumentDT,
        referentDocumentNumber,
        sdcDateTime,
        taxItems,
        totalAmount,
        transactionType,
        isInsertedOffline
        `,
        all_unhandled_invoices: `
        invoiceNumber,
        userLocation,
        userUid,
        buyerCostCenter,
        buyerTin,
        cashier,       
        invoiceType,
        items,
        paymentMethod,
        referentDocumentDT,
        referentDocumentNumber,
        sdcDateTime,
        taxItems,
        totalAmount,
        transactionType,
        isInsertedOffline
        `,
        all_advance_open_invoices: `
        invoiceNumber,
        userLocation,
        userUid,
        advanceAmount,     
        items,
        linkedInvoices,
        linkedRefund,
        timestamp,
        isInsertedOffline
        `,
        all_advance_old_invoices: `
        invoiceNumber,
        userLocation,
        userUid,
        buyerCostCenter,
        buyerTin,
        cashier,
        dateAndTimeOfIssue,
        internalData,        
        invoiceType,
        items,
        paymentMethod,
        referentAction,
        referentDocumentDT,
        referentDocumentNumber,
        sdcDateTime,
        taxItems,
        totalAmount,
        transactionType,
        isInsertedOffline
        `,
        all_errors: `
        ++id,
        userUid,
        method_name,
        file_name,
        params,
        error`,

        checks: `
        uid,
        userUid,
        price,
        qty,
        date,
        object`,

        items: `
        uid,
        userUid,
        image,
        ingredients,
        quantity,
        name,
        category,
        vat,
        unit,
        ean,
        price,
        code,
        isInsertedOffline`,

        customers: `
        uid,
        userUid,
        name,
        pib,
        mb,
        address,
        city,
        telephone,
        email,
        contactPerson,
        isInsertedOffline`,

        operators: `
        uid,
        userUid,
        group,
        secret,
        username,
        isInsertedOffline`,

        settings: `
        accounting,
        userUid,
        advance,
        articles,
        card,
        cash,
        change,
        theme,
        virman,
        isInsertedOffline`
});

export const createDB = () => {
    return offlineDB.open().catch(e => {
        console.error("createDB - offlineDB.open", e);
    });
};

// -------------- INVOICES -------------------
const handleInvoiceType = (invoice) => {
    if (invoice.transactionType === TRANSACTION_TYPE.refund) {
        if (invoice.invoiceType !== INVOICE_TYPE.copy && invoice.invoiceType !== INVOICE_TYPE.proforma && invoice.invoiceType !==
            INVOICE_TYPE.training) {
            return offline_tables.all_refunded_invoices;
        }
    }
    switch (invoice.invoiceType) {
        case INVOICE_TYPE.normal:
            if (AUTH.currentUser.email === 'graduzice@becejprevoz.com') {
                return offline_tables.all_tickets
            }
            return offline_tables.all_normal_invoices
        case INVOICE_TYPE.proforma:
            return offline_tables.all_accounting_invoices
        case INVOICE_TYPE.copy:
            return offline_tables.all_copies_invoices
        case INVOICE_TYPE.training:
            return offline_tables.all_training_invoices
        case INVOICE_TYPE.advance:
            return offline_tables.all_advance_invoices
        default:
            return offline_tables.all_unhandled_invoices
    }
};

export async function putInvoiceOffline(invoice) {
    if (invoice && AUTH.currentUser) {
        try {
            let tableName = handleInvoiceType(invoice);
            offlineDB.open().then(async db => {
                const table = db.table(tableName)
                if (table) {
                    let splitInvoiceNumber = [
                        "", ""
                    ]
                    if (invoice.invoiceNumber) {
                        splitInvoiceNumber = invoice.invoiceNumber.split('-')
                    } else {
                        console.error(invoice, " ||| ||")
                    }

                    let locationUserUid = splitInvoiceNumber[0] + AUTH.currentUser.uid
                    let exist = AUTH.currentUser.email === 'graduzice@becejprevoz.com' ?
                        await table.where('timestamp').equals(invoice.timestamp).first() :
                        await table.where('invoiceNumber').equals(invoice.invoiceNumber).first()
                    if (!exist) {
                        table.put({
                            ...invoice,
                            userUid: AUTH.currentUser.uid,
                            userLocation: locationUserUid
                        })
                    }
                }
            })
        } catch (e) {
            console.error("putInvoiceOffline", e)
        }
    }
}

export async function getLastInsertedOfflineInvoice() {
    try {
        return offlineDB.open().then(async db => {
            let tables = [
                offline_tables.all_accounting_invoices,
                offline_tables.all_refunded_invoices,
                offline_tables.all_normal_invoices,
                offline_tables.all_training_invoices,
                offline_tables.all_copies_invoices,
                offline_tables.all_advance_invoices,
                offline_tables.all_tickets]
            let lastInvoice;
            for (const table1 of db.tables) {
                if (tables.includes(table1.name)) {
                    let invoice = await table1.orderBy('sdcDateTime')
                        .filter((item) => item.userUid === AUTH.currentUser.uid && item.isInsertedOffline === false)
                        .reverse().first()
                    if (!lastInvoice) {
                        lastInvoice = invoice;
                    } else {
                        if (invoice) {
                            if (moment(invoice.sdcDateTime).isAfter(moment(lastInvoice.sdcDateTime))) {
                                lastInvoice = invoice
                            }
                        }
                    }
                }
            }
            return lastInvoice;
        })
    } catch (e) {
        console.error("getLastInsertedOfflineInvoice", e)
        return undefined;
    }
}

export async function getFirstInsertedOfflineInvoice() {
    try {
        return offlineDB.open().then(async db => {
            let tables = [
                offline_tables.all_accounting_invoices,
                offline_tables.all_refunded_invoices,
                offline_tables.all_normal_invoices,
                offline_tables.all_training_invoices,
                offline_tables.all_copies_invoices,
                offline_tables.all_advance_invoices,
                offline_tables.all_tickets]
            let firstInvoice;
            for (const table1 of db.tables) {
                if (tables.includes(table1.name)) {
                    let invoice = await table1.orderBy('sdcDateTime')
                        .filter((item) => item.userUid === AUTH.currentUser.uid && item.isInsertedOffline === false)
                        .first()
                    if (!firstInvoice) {
                        firstInvoice = invoice;
                    } else {
                        if (invoice) {
                            if (moment(invoice.sdcDateTime).isBefore(moment(firstInvoice.sdcDateTime))) {
                                firstInvoice = invoice
                            }
                        }
                    }
                }
            }
            return firstInvoice;
        })
    } catch (e) {
        console.error("getLastInsertedOfflineInvoice", e)
        return undefined;
    }
}

export async function getRefundedOfflineInvoiceByReferentDocumentNumber(referentDocumentNumber) {
    return offlineDB.open().then(async db => {
        let table = db.table(offline_tables.all_refunded_invoices);
        return table.where("referentDocumentNumber").equalsIgnoreCase(referentDocumentNumber).first();
    });
}

export async function getAllRefundedOfflineInvoiceByReferentDocumentNumber(referentDocumentNumber) {
    try {
        const db = await offlineDB.open();
        const table = db.table(offline_tables.all_refunded_invoices);
        return await table.where("referentDocumentNumber").equalsIgnoreCase(referentDocumentNumber).toArray();
    } catch (error) {
        console.error("Error fetching refunded invoices:", error);
        throw error;
    }
}


export async function getAllOfflineInvoiceForReportByItemName(location, itemName) {
    return offlineDB.open().then(async db => {
        let tables = [offline_tables.all_refunded_invoices, offline_tables.all_normal_invoices,
            offline_tables.all_advance_invoices]
        let all = [];
        for (const table1 of db.tables) {
            if (tables.includes(table1.name)) {
                let invoices;
                if (location) {
                    invoices = await table1.filter(invoice => {
                        return invoice.userUid === AUTH.currentUser.uid &&
                            invoice.invoiceNumber.startsWith(location) &&
                            invoice.items.some(item => item.name.startsWith(itemName))
                    }).toArray()
                } else {
                    invoices = await table1.filter(invoice => {
                        return invoice.userUid === AUTH.currentUser.uid &&
                            invoice.items.some(item => item.name.startsWith(itemName))
                    }).toArray()
                }
                all = [...all, ...invoices]
            }
        }
        return all;
    });
}

//---ITEMS---
export async function putItemOffline(item) {
    return offlineDB.open().then(db => {
        const table = db.table(offline_tables.items);
        try {
            offlineDB.open().then(async _ => {
                if (table) {
                    let exists = await table.where('uid').equals(item.uid).first()
                    if (!exists) {
                        table.put({
                            ...item,
                            userUid: AUTH.currentUser.uid
                        });
                    }
                }
            })
        } catch (e) {
            console.error(e, 'putItemOffline a')
        }
    })
}

const getOfflineDB = async () => {
    try {
        if (offlineDB.isOpen()) {
            return offlineDB;
        }
        return await offlineDB.open();
    } catch (e) {
        console.error('getOfflineDB', e);
    }
};

export async function putItemsOffline(items = []) {
    try {
        const db = await getOfflineDB();
        const table = db.table(offline_tables.items);
        if (table) {
            for (const item of items) {
                const offlineItem = await table.get(item.uid);
                table.put({
                    ...offlineItem,
                    ...item,
                    userUid: AUTH.currentUser.uid
                });
            }
        }
    } catch (e) {
        console.error('DEXIE - putItemsOffline', e);
    }
}

export async function updateItemFieldOffline(uid, field, value) {
    try {
        const db = await getOfflineDB();
        const table = db.table(offline_tables.items);
        if (table) {
            const exists = await table.where('uid').equals(uid).first();
            if (exists) {
                return table.update(uid, { [field]: value });
            }
        }
    } catch (e) {
        console.error('DEXIE - updateItemFieldOffline', e);
    }
}

// OPERATERI
export async function putOperatorsOffline(operators = []) {
    return offlineDB.open().then(db => {
        const table = db.table(offline_tables.operators);
        if (table) {
            operators.forEach(item => {
                table.put({
                    ...item,
                    userUid: AUTH.currentUser.uid
                })
            })
        }
    });
}

export async function getOfflineInvoiceByInvoiceNumber(invoiceNumber) {
    return offlineDB.open().then(async db => {
        let tables = [offline_tables.all_accounting_invoices, offline_tables.all_refunded_invoices,
            offline_tables.all_normal_invoices, offline_tables.all_training_invoices,
            offline_tables.all_copies_invoices];
        for (const table1 of db.tables) {
            if (tables.includes(table1.name)) {
                let invoice = await table1.where("invoiceNumber").equals(invoiceNumber).first();
                if (invoice) {
                    return invoice;
                }
            }
        }
        return undefined;
    });
}

export async function getAllOfflineInvoicesFromTables() {
    try {
        const db = await offlineDB.open();
        let tables = [
            offline_tables.all_accounting_invoices,
            offline_tables.all_normal_invoices,
            offline_tables.all_training_invoices,
            offline_tables.all_copies_invoices,
            offline_tables.all_refunded_invoices
        ];

        const arr = [];

        for (const table1 of db.tables) {
            if (tables.includes(table1.name)) {
                let invoice = await table1.toArray();
                arr.push(invoice);
            }
        }

        const hash = {};
        const merged = [];

        arr.forEach((arr) => {
            arr.forEach((data) => {
                if (!hash[data.invoiceNumber]) {
                    hash[data.invoiceNumber] = true;
                    merged.push(data);
                }
            });
        });

        return sortByDateDescending(merged);
    } catch (e) {
        console.error("getLastInsertedOfflineInvoice", e);
        return undefined;
    }
}

function parseSafeDateTime(dateTimeStr) {
    if (!dateTimeStr) return null;

    const cleaned = dateTimeStr.replace(/(\.\d{3})\d+/, '$1');
    return moment(cleaned);
}

export async function extractAllItemsDetailsFromOfflineInvoices(
    filters,
    apiFetchFunction,
    page,
    rowsPerPage,
    sortDesc = true
) {
    try {
        const db = await offlineDB.open();
        const tables = [offline_tables.all_normal_invoices];

        let unassociatedItems = [];

        function calculatePDV(totalAmount, taxItems, label, quantity = 1) {
            const tax = taxItems?.find((t) => t.label === label);
            return tax ? extractPDV(totalAmount / (quantity || 1), tax.rate) : { base: 0, pdv: 0 };
        }
        function extractPDV(totalAmount, rate) {
            const base = totalAmount / (1 + rate / 100);
            const pdv = totalAmount - base;
            return { base: +base.toFixed(2), pdv: +pdv.toFixed(2) };
        }

        const from = filters?.dateFrom ? moment(filters.dateFrom).startOf("day") : null;
        const to   = filters?.dateTo   ? moment(filters.dateTo).startOf("day")   : null;

        for (const table of db.tables) {
            if (!tables.includes(table.name)) continue;

            const invoices = await table.toArray();
            for (const invoice of invoices) {
                if (!invoice || !Array.isArray(invoice.items)) continue;

                const saleDt = parseSafeDateTime(invoice.sdcDateTime);

                // datum offline (radi samo ako su oba zadana)
                const isInRange = (!from || !to) || (saleDt && saleDt.isBetween(from, to, null, "[)"));
                if (!isInRange) continue;

                // issuedFor / prevoznik (offline)
                if (filters?.issuedFor?.id != null && invoice.internalData?.operatorId !== filters.issuedFor.id) continue;

                // cashier (offline)
                if (filters?.cashier) {
                    const invCashier = String(invoice.cashier ?? "");
                    if (!invCashier.toLowerCase().includes(String(filters.cashier).toLowerCase())) continue;
                }

                // invoiceNumber (offline)
                if (filters?.invoiceNumber) {
                    const invNo = String(invoice.invoiceNumber ?? "");
                    if (!invNo.toLowerCase().includes(String(filters.invoiceNumber).toLowerCase())) continue;
                }

                // startStation / endStation (offline) — uporedi ID kao string
                const invStart = String(invoice?.internalData?.startStation ?? "");
                const invEnd   = String(invoice?.internalData?.endStation ?? "");
                if (filters?.startStation?.id != null && invStart !== String(filters.startStation.id)) continue;
                if (filters?.endStation?.id   != null && invEnd   !== String(filters.endStation.id))   continue;

                // stavke bez passengerUid
                let itemsWithoutPassenger = invoice.items.filter(
                    (item) => !item.passengerUid || item.passengerUid.length === 0
                );

                // itemName (offline) — filter na nivou stavki
                if (filters?.itemName) {
                    const q = String(filters.itemName).trim().toLowerCase();
                    itemsWithoutPassenger = itemsWithoutPassenger.filter((item) =>
                        String(item?.name ?? "").toLowerCase().includes(q)
                    );
                }

                if (itemsWithoutPassenger.length === 0) continue;

                const parentTicketIds = invoice.internalData?.ticketIds || [];

                itemsWithoutPassenger.forEach((item) => {
                    const pdvInfo = calculatePDV(
                        item.totalAmount,
                        invoice.taxItems,
                        item.labels?.[0],
                        item.quantity
                    );

                    unassociatedItems.push({
                        invoiceNumber: invoice.invoiceNumber,
                        transactionType: invoice.transactionType,
                        invoiceType: invoice.invoiceType,
                        cashier: invoice.cashier,
                        saleTime: saleDt, // sortiranje/paginacija
                        itemName: item.name,
                        itemTotalAmount: item.totalAmount,
                        itemBaseAmount: pdvInfo.base,
                        itemPdvAmount: pdvInfo.pdv,
                        parentTicketIds,
                    });
                });
            }
        }

        if (unassociatedItems.length === 0) return [];

        // —— PAGINACIJA PRE POZIVA BE (šaljemo samo IDs sa te strane) ——
        const start = (page || 0) * (rowsPerPage || 10);
        const end   = start + (rowsPerPage || 10);
        const pageItems = unassociatedItems.slice(start, end);
        if (pageItems.length === 0) return [];

        // IDs samo sa te strane
        const pageIdsSet = new Set();
        for (const it of pageItems) (it.parentTicketIds || []).forEach((id) => pageIdsSet.add(id));

        // Ako nema ID-jeva, vrati stranu bez match-a
        if (pageIdsSet.size === 0) {
            const onlyThisPage = sortSaleDt(pageItems, "saleTime");
            const ordered = sortDesc ? onlyThisPage : [...onlyThisPage].reverse();
            // clamp na rowsPerPage (ionako je već toliko)
            return ordered.slice(0, rowsPerPage || 10);
        }

        // —— BE poziv samo sa ID-jevima te strane ——
        const ticketDetailsFromBackend = await apiFetchFunction(Array.from(pageIdsSet));
        const tickets = Array.isArray(ticketDetailsFromBackend?.data)
            ? ticketDetailsFromBackend.data
            : Array.isArray(ticketDetailsFromBackend)
                ? ticketDetailsFromBackend
                : [];

        // —— Ekspanzija (fan-out) samo za stavke na TEKUĆOJ STRANI ——
        const finalResult = [];
        const isStationService = (name) => (name || "").toUpperCase().includes("STANICNA USLUGA");

        for (const item of pageItems) {
            const relevantOneWayTickets = tickets.filter(
                (t) => item.parentTicketIds.includes(t.ticketId) && t.outboundTicketId === null
            );

            if (relevantOneWayTickets.length === 0) {
                finalResult.push({ ...item, matchedTicket: null });
                continue;
            }

            if (isStationService(item.itemName)) {
                // fan-out (može probiti 25)
                for (const t of relevantOneWayTickets) {
                    finalResult.push({ ...item, matchedTicket: t });
                }
            } else {
                finalResult.push({ ...item, matchedTicket: relevantOneWayTickets[0] });
            }
        }

        // —— Sort + CLAMP (garantuje max rowsPerPage redova) ——
        const sorted = sortSaleDt(finalResult, "saleTime");
        const ordered = sortDesc ? sorted : [...sorted].reverse();
        return {result: ordered.slice(0, rowsPerPage || 10), totalElements: unassociatedItems.length};

    } catch (e) {
        console.error("extractAllItemsDetailsFromOfflineInvoices", e);
        return [];
    }
}



export async function extractAllItemsWithUidFromOfflineInvoices(dateFrom, dateTo,operator, carrier, sortDesc = true) {
    try {
        const db = await offlineDB.open();
        const tables = [
            offline_tables.all_normal_invoices,
            offline_tables.all_refunded_invoices
           ];
        const result = [];
        function calculatePDV(totalAmount, taxItems, label, quantity) {
            const tax = taxItems?.find(t => t.label === label);
            return tax ? extractPDV(totalAmount / quantity, tax.rate) : { base: 0, pdv: 0 };
        }

        function extractPDV(totalAmount, rate) {
            const base = totalAmount / (1 + rate / 100);
            const pdv = totalAmount - base;
            return {
                base: parseFloat(base.toFixed(2)),
                pdv: parseFloat(pdv.toFixed(2))
            };
        }

        const from = dateFrom ? moment(dateFrom).startOf('day') : null;
        const to = dateTo ? moment(dateTo).startOf('day') : null;

        for (const table of db.tables) {
            if (tables.includes(table.name)) {
                const invoices = await table.toArray();
                for (const invoice of invoices) {
                    if (!invoice || !Array.isArray(invoice.items)) continue;
                    const saleDt = parseSafeDateTime(invoice.sdcDateTime);

                    const isInRange =
                        (!from || !to) || (saleDt && saleDt.isBetween(from, to, null, '[)'));

                    if (!isInRange) continue;
                    if(operator && invoice.cashier !== operator){
                        continue;
                    }
                    if(carrier && invoice.internalData?.operatorId !== carrier){
                        continue;
                    }
                    invoice.items
                        .filter(item =>
                            (!item.passengerUid || item.passengerUid.length === 0 || item.passengerUid === "") &&
                            !(item?.name?.toUpperCase().includes("JEDAN") || item?.name?.toUpperCase().includes("POVRATNA") || item?.name?.toUpperCase().includes("POVRATAK") || item?.name?.toUpperCase().includes("DNEVNA"))
                        )
                        .forEach((item, index) => {
                            result.push({
                                id: `${invoice.invoiceNumber}-${index}`,
                                cardId: invoice.internalData?.cardNumber?.length > 0 ? invoice.internalData?.cardNumber[index] : null,
                                ticketId: invoice.internalData?.ticketIds?.length > 0 ? invoice.internalData?.ticketIds[0] : null,
                                name: item.name,
                                invoiceNumber: invoice.invoiceNumber,
                                cashier: invoice.cashier,
                                saleDt: invoice.sdcDateTime || null,
                                price: item.unitPrice,
                                baseAndPDV: calculatePDV(item.totalAmount, invoice.taxItems, item.labels?.[0], item.quantity),
                                quantity: item.quantity,
                                totalAmount: item.totalAmount,
                                invoiceType: invoice.invoiceType,
                                transactionType: invoice.transactionType,
                                refund: invoice.transactionType === "Refund",
                                operatorId: invoice.internalData?.operatorId || null,
                            });
                        });
                }
            }
        }

        const sorted = sortSaleDt(result);
        return sortDesc ? sorted : sorted.reverse();
    } catch (e) {
        console.error("extractAllItemsWithUidFromOfflineInvoices", e);
        return [];
    }
}

// ------------ ERROR & LOGS ------------
export function storeErrorToOffline(method_name, file_name, params = [], error) {
    try {
        let stringParams = "";
        params.forEach(value => {
            stringParams = stringParams + JSON.stringify(value);
        });
        putLogToFirebase(method_name, file_name, stringParams, error);
    } catch (e) {
    }
}

export function putLogToFirebase(method_name, file_name, params, error) {
    let browser = get_browser();
    console.debug("-----------  putLogToFirebase  --------------");
    console.debug("method_name", method_name);
    console.debug("file_name", file_name);
    console.debug("params", params);
    console.debug("error", error);
    console.debug("browser", browser);
    console.debug("-------------------------");

    let obj = {
        cashier: getSessionOperator().username,
        application: "webBUS",
        version: getSessionAppVersion(),
        params: params || null,
        fileName: file_name || null,
        methodName: method_name ? method_name : null,
        error: error ? error : null,
        browser: browser || null
    };
    const colref = doc(DB, "log", "users", AUTH.currentUser.uid, Date.now().toString());
    setDoc(colref, obj).then(_ => {
        console.debug("Uspesno sacuvan LOG na firestoru");
    }).catch(_ => {
        try {
            return offlineDB.open().then(db => {
                const table = db.table("all_errors");
                if (table) {
                    return table.add({
                        method_name: method_name,
                        file_name: file_name,
                        params: params,
                        error: error
                    }, {});
                }
            });
        } catch (e) {

        }
    });
}

export async function insertAllUserInvoicesOffline() {

    const currentDate = moment();
    const firstDayOfPreviousMonth = moment(currentDate).subtract(1, 'month').startOf('month');

    const fDayOfPrevMonth = firstDayOfPreviousMonth.format('YYYY-MM-DD');

    return new Promise(async (resolve, reject) => {
        await getInvoicesByUser(null, [], resolve, reject, fDayOfPrevMonth);
    });
}

export async function insertAllUserInvoicesOfflineForPeriod(period) {
    return new Promise(async (resolve, reject) => {
        await getInvoicesByUserForPeriod([], resolve, reject, period);
    });
}

export function saveInvoiceOffline(check) {
    return offlineDB.open().then(db => {
        const table = db.table(offline_tables.checks);
        if (table) {
            return table.put({
                ...check,
                userUid: AUTH.currentUser.uid
            });
        }
    });
}
